import {BasicLayout} from "../layouts/BasicLayout";
import { Error404 } from "../pages";
import routesAdmin from "./routes.admin"
import routesClient from "./routes.client"
//CUANDO ES DEFAULT NO LLEVA LLAVES

//Juntar array de objetos [{}, {}]
const routes = [
    ...routesAdmin, ...routesClient,{        
        path: '*',
        layout: BasicLayout,
        component: Error404,
    }
];

export default routes;